import React from 'react';
import PropTypes from 'prop-types';
import { Confirm } from 'react-confirm-bootstrap';
import { MenuItem } from 'react-bootstrap/lib';
import { Permissions } from '@upstart/harmony/lib/constants';
import withUserPermission from './userPermission';

function DeleteButton({ user, onDelete }) {
  return (
    <Confirm
      onConfirm={() => onDelete(user.id)}
      body={`Are you sure you want to delete ${user.firstName} ${user.lastName}?`}
      confirmText="Confirm Delete"
      title={`Deleting ${user.firstName} ${user.lastName}`}
    >
      <MenuItem>Delete</MenuItem>
    </Confirm>
  );
}

DeleteButton.propTypes = {
  user: PropTypes.object,
  onDelete: PropTypes.func,
};

export default withUserPermission(Permissions.DELETE)(DeleteButton);
